export const HOME_SCHEDULE_STORAGE_KEYS = {
  WEEK: 'home_schedule_week',
  TEAM: 'home_schedule_team',
  GROUP: 'home_schedule_group',
} as const;

/** Last team opened on the team details pages (`/teams/:id/...`). */
export const TEAM_DETAILS_STORAGE_KEYS = {
  TEAM: 'team_details_selected_team',
} as const;

export const clearHomeScheduleCache = (): void => {
  try {
    localStorage.removeItem(HOME_SCHEDULE_STORAGE_KEYS.WEEK);
    localStorage.removeItem(HOME_SCHEDULE_STORAGE_KEYS.TEAM);
    localStorage.removeItem(HOME_SCHEDULE_STORAGE_KEYS.GROUP);
    localStorage.removeItem(TEAM_DETAILS_STORAGE_KEYS.TEAM);
  } catch (error) {
    console.warn('Error clearing session UI cache:', error);
  }
};

export const getStoredValue = (key: string, defaultValue: string): string => {
  try {
    return localStorage.getItem(key) || defaultValue;
  } catch (error) {
    console.warn('Error reading from localStorage:', error);
    return defaultValue;
  }
};

export const setStoredValue = (key: string, value: string): void => {
  try {
    localStorage.setItem(key, value);
  } catch (error) {
    console.warn('Error writing to localStorage:', error);
  }
};

export const clearStoredValue = (key: string): void => {
  try {
    localStorage.removeItem(key);
  } catch (error) {
    console.warn('Error removing from localStorage:', error);
  }
};
